export default __webpack_public_path__ + "static/media/stefano-sergole-modal.a95f965e.jpg";